import React from "react";
import DepositInfo from "./DepositInfo";
import IncludedServices from "./IncludedServices";
import PriceItem from "./PriceItem";
import { useGetPriceList } from "@/api/api";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
// import CurrencyOption from "./CurrencyOption";

const Loading = () => {
  return <Skeleton count={5} height={64} />;
};
const PriceDetails = ({ villa, currency, days }) => {
  const {
    data: prices,
    isLoading,
  } = useGetPriceList(villa?.id, currency);

  return (
    <div className="grid grid-cols-1 gap-5 mb-4 md:grid-cols-5 lg:gap-8 lg:mb-16 md:mb-8">
      {prices?.error ? (
        <span>{prices.error}</span>
      ) : isLoading ? (
        <Loading />
      ) : (
        <div className="flex flex-col gap-1 md:col-span-3">
          {prices?.data?.map((price) => {
            return <PriceItem key={price.title} price={price} days={days} />;
          })}
        </div>
      )}
      <div className="flex flex-col md:col-span-2">
        <DepositInfo villa={villa} />
        <IncludedServices includedServices={villa?.fiyata_dahil} />
      </div>
    </div>
  );
};

export default PriceDetails;
